import dJSON from 'dirty-json';

import Splide from '@splidejs/splide';

const moduleSelector = '.hero-splide';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      if (!query.data) return;

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide" data-type="${item.type}" ${item.background_color ? `style="background-color: ${item.background_color};"` : ''}>
            <div class="image-wrapper">
              <img src="${item.background}" alt="">
            </div>
            <div class="content-wrapper">
              <div class="title-section">
               ${item.kicker ? `<p class="kicker">${item.kicker}</p>` : ''}
                ${item.title ? `<h2 class="title">${item.title}</h2>` : ''}
              </div>
              <div class="description-section">
                ${item.text ? `<p class="description">${item.text}</p>` : ''}
                ${(item.button_text_1 || item.button_text_2) ? `
                  <div class="button-wrapper">
                    ${item.button_text_1 ? `<a href="${item.button_link_1}" class="btn-custom primary">${item.button_text_1}</a>` : ''}
                    ${item.button_text_2 ? `<a href="${item.button_link_2}" class="btn-custom primary">${item.button_text_2}</a>` : ''}
                  </div>
                ` : ''}
              </div>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

(() => {
  document.querySelectorAll('.hero-splide .splide').forEach((item) => {
    const slider = new Splide(item, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: 0,
      pagination: false,
      arrows: false,
      autoplay: true,
      interval: 6000,
    });
    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
